module.exports = __webpack_public_path__ + "media/images/foodpanda-932b36215a00b8540dac4e6318c37f7f.png";